module.exports = __webpack_public_path__ + "static/play_store-e71b9f4bdd914027b93bdf38522168f9.png";